<template>
  <FormWrapper
    wrapperClass="height-percent-100 overflow-y-hidden max-height-percent-100"
    bodyClass="padding-x-16 padding-top-16 height-percent-100"
    :handleSubmit="handleSubmit"
    :loading="loading"
  >
    <FormLoading :count="4" class="padding-0">
      <Input
        :title="$lang.introduction"
        :label="$lang.introduction"
        :placeholder="$lang.introduction"
        :value="form.introduction"
        name="introduction"
        id="introduction"
        type="textarea"
        :vuelidateObj="$v.form.introduction"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <Dropdown
        :title="$lang.logo"
        :label="$lang.logo"
        :placeholder="$lang.logo"
        :value="form.logo"
        name="logo"
        id="logo"
        :vuelidateObj="$v.form.logo"
        :options="logoOptions"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </FormLoading>
  </FormWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import {
  FormWrapper,
  FormLoading,
  Input,
  Dropdown,
} from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateError, toastAlert } from "@/shared/utils";
import { updateReportSetting } from "@/services";
export default {
  mixins: [inputMixin],
  components: { FormWrapper, FormLoading, Input, Dropdown },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        introduction: { required },
        logo: { required },
      },
    };
  },
  data() {
    return {
      form: {
        introduction: null,
        logo: null,
      },
      logoOptions: [
        {
          id: "rasa",
          caption: "رسا",
        },
        {
          id: "company",
          caption: this.$lang.company,
        },
      ],
      loading: false,
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(value) {
        if (value) {
          const { introduction, logo } = value;
          this.form.introduction = introduction;
          this.form.logo = this.logoOptions.find(({ id }) => id === logo);
        }
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const { id: reportSettingId } = this.data;
        const { introduction } = this.form;
        const logo = pathOr(null, ["logo", "id"], this.form);
        const response = await updateReportSetting(
          reportSettingId,
          introduction,
          logo
        );
        const { message } = response;
        toastAlert(message);
        this.handleClose();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
